<template>
  <div v-if="loading" v-loading="loading" style="widht: 100%; height: 100vh">
    <br /><br />
  </div>
  <router-view v-else></router-view>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application
 */
import { mapGetters, mapMutations } from 'vuex';
import store from './store';
import { router } from './../bootstrap';
import accountService from './services/account';
import VueI18n from 'vue-i18n';
import messages from './locale';
import numberFormats from './numberFormats';
import userAppVersionService from './services/appVersion';
import userAppToastService from './services/appToast';
import newReleaseVersion from './components/newReleaseVersion/newReleaseVersion.vue';

const i18n = new VueI18n({
  locale: process.env.language, // set locale
  messages, // set locale messages
  numberFormats, // set number formats
  fallbackLocale: 'en',
});

export default {
  data() {
    return {
      loading: false,
      isModalShow: false,
      latestApp: [],
      toastSetup: {
        config: {
          message: this.$t('static.releaseNote.toast.message'),
          dismissible: true,
          duration: 10000,
          type: 'info',
          queue: true,
          onClick: this.onclick,
          container: null,
        },
      },
    };
  },

  /**
   * The Vuex store
   */
  store,

  /**
   * The router
   */
  router,

  /**
   * The Vue i18n
   */
  i18n,

  /**
   * Computed property
   */
  computed: {
    ...mapGetters({
      account: 'account',
      toastResp: 'toastResp',
      latestAppVersion: 'latestAppVersion',
    }),
  },

  /**
   * Watch property
   */
  watch: {
    account(account) {
      if (account.language) i18n.locale = account.language;
    },

    latestAppVersion(latestAppVersion) {
      this.latestApp = latestAppVersion.items;
      if (this.toastResp.items === false) this.isModalShow = false;
      this.checkToastShow(this.latestApp);
    },

    toastResp(toastResp) {
      if (toastResp.items === true) {
        this.isModalShow = true;
        this.modalReleaseNote();
      }
    },

    $route(to, from) {
      if (to.name !== 'auth.login' || to.path !== '/login') {
        if (from.name === 'auth.login' || from.path === '/login') {
          this.modalReleaseNote(false, true);
        }
      } else {
        this.$toast.clear();
      }
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    /**
     * Activates the modal
     */
    activateModal() {
      this.setModalContent(() => newReleaseVersion);
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Toast onclick
     */
    onclick() {
      this.$toast.clear();
      Promise.resolve(accountService.updateUserAppToast('true')).then(() => {
        location.reload(true);
      });
    },

    /**
     * Show up modal release note
     */
    modalReleaseNote(showModal = true, onLogin = false) {
      Promise.all([userAppVersionService.fetchUserAppVersion()]).then(() => {
        if (this.latestApp !== 'updated' && showModal === true) {
          this.isModalShow = false;
          setTimeout(() => this.activateModal(), 1500);
        }
        if (onLogin === true && this.latestApp !== 'updated') {
          this.$toast.open(this.toastSetup.config);
        }
      });
    },

    /**
     * Get toast if clicked respo
     */
    taostResponse() {
      Promise.all([userAppToastService.fetchUserAppToast()]).then(() => {});
    },

    /**
     * Check if toast msg show
     */
    checkToastShow(latestAppVersion) {
      if (
        this.isModalShow === false &&
        latestAppVersion !== 'updated' &&
        this.$store.state.auth.authenticated === true
      ) {
        if (this.latestAppVersion.items.data.release_silent === 0) {
          this.$toast.open(this.toastSetup.config);
        }
      }
    },
  },

  /**
   * Fires when the app has been mounted
   */
  created() {
    // If the user is authenticated,
    // fetch the data from the API
    if (!this.$store.state.auth.authenticated) return;
    /**
     *  Check new version of the app
     */
    this.taostResponse();
    this.loading = true;
    accountService
      .find()
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>
<style src="./../assets/stylus/app.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// index.vue?513d284e